/**
 * Persist a patch onto the stored auth user.
 *
 * `AuthContext` hydrates its `user` from the `TaxHive_auth_user` localStorage
 * key on mount and exposes no setter today. After a self-service save (profile
 * name, preferences, …) we write the patch back here so a reload reflects the
 * change. Callers should also update their own React state for immediate UI
 * feedback within the current session.
 */

import { AUTH_STORAGE_KEYS } from '@/types/auth.types'
import type { AuthUser } from '@/types/auth.types'

export function persistAuthUserPatch(patch: Partial<AuthUser>): void {
  try {
    const raw =
      sessionStorage.getItem(AUTH_STORAGE_KEYS.USER) ||
      localStorage.getItem(AUTH_STORAGE_KEYS.USER)
    if (!raw) return
    const current = JSON.parse(raw) as AuthUser
    const updated = JSON.stringify({ ...current, ...patch })
    if (sessionStorage.getItem(AUTH_STORAGE_KEYS.USER)) {
      sessionStorage.setItem(AUTH_STORAGE_KEYS.USER, updated)
    }
    if (localStorage.getItem(AUTH_STORAGE_KEYS.USER)) {
      localStorage.setItem(AUTH_STORAGE_KEYS.USER, updated)
    }
  } catch {
    /* storage unavailable (private mode) — in-session state still updated */
  }
}
